function createCompanyActions({ apiFetch, syncFromApi }) {
  const syncCompaniesInBackground = () => {
    Promise.resolve(syncFromApi(undefined, 'companies')).catch(() => {
      // Não bloqueia UX de salvar/editar por falha de sincronização.
    });
  };

  const createCompany = async (payload, options = {}) => {
    const data = await apiFetch('/api/companies', {
      method: 'POST',
      body: JSON.stringify(payload),
      ...options,
    });
    syncCompaniesInBackground();
    return data;
  };

  const updateCompany = async (companyId, payload, options = {}) => {
    const data = await apiFetch(`/api/companies/${companyId}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
      ...options,
    });
    syncCompaniesInBackground();
    return data;
  };

  const deleteCompany = async (companyId, password) => {
    await apiFetch(`/api/companies/${companyId}`, {
      method: 'DELETE',
      body: JSON.stringify({ password }),
    });
    syncCompaniesInBackground();
  };

  const testCompanySiengeConnection = async (companyId, body = {}) =>
    apiFetch(`/api/companies/${companyId}/test-sienge-connection`, {
      method: 'POST',
      body: JSON.stringify(body),
    });

  const testSiengeCredentialsPreview = async (payload) =>
    apiFetch('/api/companies/test-sienge-credentials', {
      method: 'POST',
      body: JSON.stringify(payload),
    });

  const fetchCompaniesSiengeLive = async () => apiFetch('/api/companies/sienge-live-status');
  const lookupCompanyCreditorInSienge = async (companyId, query = {}, options = {}) => {
    const params = new URLSearchParams();
    if (query?.cpf) params.set('cpf', String(query.cpf));
    if (query?.cnpj) params.set('cnpj', String(query.cnpj));
    const qs = params.toString();
    return apiFetch(`/api/companies/${companyId}/creditors/live-lookup${qs ? `?${qs}` : ''}`, options);
  };

  return {
    createCompany,
    updateCompany,
    deleteCompany,
    testCompanySiengeConnection,
    testSiengeCredentialsPreview,
    fetchCompaniesSiengeLive,
    lookupCompanyCreditorInSienge,
  };
}

export { createCompanyActions };
